/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LegalDocumentVersions interface.
 */
export function instanceOfLegalDocumentVersions(value) {
    if (!('privacy' in value) || value['privacy'] === undefined)
        return false;
    if (!('terms' in value) || value['terms'] === undefined)
        return false;
    return true;
}
export function LegalDocumentVersionsFromJSON(json) {
    return LegalDocumentVersionsFromJSONTyped(json, false);
}
export function LegalDocumentVersionsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'privacy': json['privacy'],
        'terms': json['terms'],
    };
}
export function LegalDocumentVersionsToJSON(json) {
    return LegalDocumentVersionsToJSONTyped(json, false);
}
export function LegalDocumentVersionsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'privacy': value['privacy'],
        'terms': value['terms'],
    };
}
